import script from "./campaignsModal.vue?vue&type=script&setup=true&lang=jsx"
export * from "./campaignsModal.vue?vue&type=script&setup=true&lang=jsx"

import "./campaignsModal.vue?vue&type=style&index=0&id=b038115e&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b038115e"]])

export default __exports__